// First-touch entry attribution. On the visitor's first arrival, persist where
// they came from (referrer, landing path, utm_*) in first-party cookies. The
// backend attribution middleware reads these on every request and stamps them
// onto the user at signup (users.acquisition_* columns, migration 056).
//
// The cookies are Marketing-category: they are written only with Advertisement
// consent. The landing snapshot is taken at page load and held in memory, so
// a visitor who accepts later in the same page life is still captured from
// the URL and referrer they arrived with, as the marketing site does
// (landscope-home src/lib/attribution.ts).
import { buildCookie, cookieNamesIn, currentCookieScope } from './attributionCookies';
const LANDING_COOKIE = 'ls_entry_landing';
const REFERRER_COOKIE = 'ls_entry_referrer';
const UTM_COOKIES = {
    utm_source: 'ls_entry_utm_source',
    utm_medium: 'ls_entry_utm_medium',
    utm_campaign: 'ls_entry_utm_campaign',
};
const MAX_VALUE_LENGTH = 512;
const setCookie = (name, value) => {
    document.cookie = buildCookie(name, encodeURIComponent(value.slice(0, MAX_VALUE_LENGTH)), currentCookieScope());
};
// The current visit's attribution, cached by captureEntryAttribution before
// utm_* params are stripped from the URL.
let capturedEntry = null;
export const getEntryAttribution = () => capturedEntry !== null && capturedEntry !== void 0 ? capturedEntry : readCurrentEntryAttribution();
const readCurrentEntryAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const referrer = document.referrer;
    const external = referrer && !referrer.includes(`//${window.location.hostname}`) ? referrer : '';
    return {
        referrer: external,
        landingPath: window.location.pathname + window.location.search,
        utmSource: params.get('utm_source') || '',
        utmMedium: params.get('utm_medium') || '',
        utmCampaign: params.get('utm_campaign') || '',
    };
};
// Snapshots this visit's entry attribution into page memory, then strips
// utm_* params from the URL. Writes nothing to the browser.
export const captureEntryAttribution = () => {
    capturedEntry = readCurrentEntryAttribution();
    const params = new URLSearchParams(window.location.search);
    const hadUtm = Object.keys(UTM_COOKIES).some((p) => params.has(p));
    if (hadUtm) {
        Object.keys(UTM_COOKIES).forEach((p) => params.delete(p));
        const query = params.toString();
        const cleaned = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
        window.history.replaceState(null, '', cleaned);
    }
};
// Writes the snapshot to the entry cookies. First touch wins: nothing is
// written when the landing cookie already exists (set here or by the marketing
// site). Call only with Advertisement consent.
export const writeEntryAttributionCookies = () => {
    if (cookieNamesIn(document.cookie).has(LANDING_COOKIE)) {
        return;
    }
    const entry = getEntryAttribution();
    setCookie(LANDING_COOKIE, entry.landingPath);
    if (entry.referrer) {
        setCookie(REFERRER_COOKIE, entry.referrer);
    }
    if (entry.utmSource) {
        setCookie(UTM_COOKIES.utm_source, entry.utmSource);
    }
    if (entry.utmMedium) {
        setCookie(UTM_COOKIES.utm_medium, entry.utmMedium);
    }
    if (entry.utmCampaign) {
        setCookie(UTM_COOKIES.utm_campaign, entry.utmCampaign);
    }
};
